import { createContext, useEffect, useState } from "react";
import useApi from "../hooks/ApiHook";

const UserContext = createContext({});

export const UserProvider = ({ children }) => {

	const [ self, setSelf ] = useState();
	const [ loading, setLoading ] = useState(true);
	const api = useApi();

	useEffect(() => {
		api.get('users/self').then(({ data }) => setSelf(data));
	}, []);

	useEffect(() => {
		setLoading(!self);
	}, [self]);

	return (
		<UserContext.Provider value={{ self, loading }}>
			{children}
		</UserContext.Provider>
	);
}

export default UserContext;